import { objetoChatGlobal } from './Chat/objeto_chat';
import { Historial } from './objeto_historial';
import {Preguntas, ProPlataforma} from './Solicitud/objeto_solicitud';
import {conversionBooleanoJson, conversionFechaJson, conversionNumberJson, conversionStringJson, convertirFechaFirebase, esFechaEntregaValida} from './utiles_objetos';

export class ServicioAgendado {
    constructor({
        //parametros iniciales
        codigo = "",
        materia = "",
        fechasistema = new Date(),
        cliente = 0,
        preciocobrado = 0,
        fechaentrega = new Date(),
        tutor = "",
        preciotutor = 0,
        identificadorcodigo = "",
        idsolicitud = 0,
        idcontable = 0,
        ultimaModificacion = 0,
        notasContabilidad = "",
        notaObtenida = 0,
        servicioVerificado = false, //para UNAD VERIFICADO POR HUMANO
        nombreEmpresa = "", //nombre de empresa

        //listas
        pagos = [],
        historial = [],
        entregasTrabajo = [],
        //lista de reisiones, aun no

        //entrega de tutor
        linkEntregaTutor = "",
        entregatutorFecha = new Date(),
        entregaClienteFecha  = new Date(),

        //Especiales para servicios referidos, como tesis
        referidoPor = "",
        gananciaReferido = 0,
        percentReferido = 0,

        //objetotesis
        objetoTesis = new ObjetoTesis(),

        //relacionalBackend
        proPlataforma = {},

        //seguir
        codigoReferenciaCamapa = "",

        //objeto para asesorias
        ObjetoAsesoria = {},

        creadoPor = '',

        //aviso a cliente
        avisoClienteEntrega = false,

        //preguntas
        preguntas = [],

        //generar explicacion de IA
        generateCalificacionIA = "",

        previewEntrega = [],

        //gastosServicios 
        gastosServicio = [],

        //revisiones
        revision = new RevisionServicio(),
        chatRevision = [],
        

    } = {}) {
        this.codigo = codigo;
        this.materia = materia;
        this.fechasistema = fechasistema;
        this.cliente = cliente;
        this.preciocobrado = preciocobrado;
        this.fechaentrega = fechaentrega;
        this.tutor = tutor;
        this.preciotutor = preciotutor;
        this.identificadorcodigo = identificadorcodigo;
        this.idsolicitud = idsolicitud;
        this.idcontable = idcontable;
        this.ultimaModificacion = ultimaModificacion;
        this.notasContabilidad = notasContabilidad;
        this.notaObtenida = notaObtenida;
        this.servicioVerificado = servicioVerificado;
        this.nombreEmpresa = nombreEmpresa;
        
        // Asignación de listas
        this.pagos = pagos;
        this.historial = historial;
        this.entregasTrabajo = entregasTrabajo;
        
        // Asignación de entregas de tutor
        this.linkEntregaTutor = linkEntregaTutor;
        this.entregatutorFecha = entregatutorFecha;
        this.entregaClienteFecha = entregaClienteFecha;
        
        // Asignación de campos especiales para tesis
        this.referidoPor = referidoPor;
        this.gananciaReferido = gananciaReferido;

        //RELACIONAL BACKEND
        this.proPlataforma = proPlataforma;

        this.objetoTesis = objetoTesis;

        this.codigoReferenciaCamapa = codigoReferenciaCamapa;

        this.ObjetoAsesoria = ObjetoAsesoria;
        this.creadoPor = creadoPor;

        this.avisoClienteEntrega = avisoClienteEntrega;

        this.preguntas = preguntas;
        this.generateCalificacionIA = generateCalificacionIA;

        this.previewEntrega = previewEntrega;

        this.gastosServicio = gastosServicio;

        this.revision = revision;
        this.chatRevision = chatRevision;
        this.percentReferido = percentReferido;
    }

    static fromJson(json){
        const fechaSistemaLocal = convertirFechaFirebase(json['fechasistema']);
        const fechaEntregaLocal = convertirFechaFirebase(json['fechaentrega']);
        const entregaTutorFechaLocal = convertirFechaFirebase(json['entregatutorFecha']);
        const entregaClienteFechaLocal = convertirFechaFirebase(json['entregaClienteFecha']);
        

        const pagos =  Array.isArray(json['pagos']) 
            ? json['pagos'].map(pagosDATA => RegistrarPagos.fromJson(pagosDATA))
            : [];

        const historial =  Array.isArray(json['historial']) 
            ? json['historial'].map(historialDATA => Historial.fromJson(historialDATA))
            : [];

        //gastos
        const gastosServicioLocal = Array.isArray(json['gastosServicio'])
        ? json['gastosServicio'].map(gData => GastoServicio.fromJson(gData))
        : [];

        //revision
        const revisionLocal = json.revision 
            ? RevisionServicio.fromJson(json.revision) 
            : new RevisionServicio();

        //nombre empresa y referidopor
        const referidoPorLocal = json['referidoPor'] ?? '';
        const preciocobradoLocal = json['preciocobrado'] ?? 0;
        const precioTutorLocal = json['preciotutor'] ?? 0;

        //A LA GANANCIA LOCAL TOCA RESTARLE LOS GASTOS DE SERVICIO LOCAL
        const percentReferidoLocal = json['percentReferido'] ?? 0.40;

        const ganaciaLocal = preciocobradoLocal - precioTutorLocal;
        let gananciaReferidoLocal = 0;
        if(referidoPorLocal !== ""){
            gananciaReferidoLocal =  ganaciaLocal * percentReferidoLocal ; // 40% FIJOS, MANEJADO EN EL PASADO
        } 

        return new ServicioAgendado({
            codigo: json['codigo'] ?? 0,
            materia: json['materia'] ?? '',
            fechasistema: fechaSistemaLocal,
            cliente: json['cliente'] ?? 0,
            preciocobrado: preciocobradoLocal,
            fechaentrega: fechaEntregaLocal,
            tutor: json['tutor'] ?? '',
            preciotutor: precioTutorLocal,
            identificadorcodigo: json['identificadorcodigo'] ?? '',
            idsolicitud: json['idsolicitud'] ?? 0,
            idcontable: json['idcontable'] ?? 0,
            ultimaModificacion: json['ultimaModificacion'] ?? 0,
            notasContabilidad: json['notasContabilidad'] ?? '', // Corregí 'son' por 'json'
            notaObtenida: json['notaObtenida'] ?? -1,
            servicioVerificado: json['servicioVerificado'] ?? false,
            nombreEmpresa: json['nombreEmpresa'] ?? 'Error en nombre Empresa?',

            // listas, cuadrarlas
            pagos: pagos,
            historial: historial, //toca crear un objeto
            entregasTrabajo: json.entregasTrabajo ? json.entregasTrabajo.map(entrega => EntregasParciales.fromJson(entrega)) : [],

            // entregas de tutores
            linkEntregaTutor: json['linkEntregaTutor'] ?? 'No ha sio entregao',
            entregatutorFecha: entregaTutorFechaLocal,
            entregaClienteFecha: entregaClienteFechaLocal,

            // referidos
            referidoPor: referidoPorLocal,
            gananciaReferido: gananciaReferidoLocal,  

            //proplataforma
            proPlataforma: json.proPlataforma ? ProPlataforma.fromJson(json.proPlataforma) : new ProPlataforma(),

            objetoTesis: json.objetoTesis ? ObjetoTesis.fromJson(json.objetoTesis) : new ObjetoTesis(),

            codigoReferenciaCamapa: json['codigoReferenciaCamapa'] ?? '',
            ObjetoAsesoria: json.ObjetoAsesoria,
            //htmlLink
            //hangoutLink
            //enlaceGrabacion

            creadoPor: json['creadoPor'] ?? '',

            avisoClienteEntrega: json['avisoClienteEntrega'] ?? false,

            //PROCESAMIENTO DE PREGUNTAS
            preguntas: (json['preguntas'] || []).map(preguntasData => Preguntas.fromJson(preguntasData)),
            generateCalificacionIA: json['generateCalificacionIA'] ?? 'Aun no generado',

            previewEntrega: (json['previewEntrega'] || []),

            //gastos
            gastosServicio: gastosServicioLocal,
            revision: revisionLocal,
            chatRevision: Array.isArray(json['chatRevision']) 
                ? json['chatRevision'].map(m => objetoChatGlobal.fromJson(m)) 
                : [],
            percentReferido: percentReferidoLocal,
            
            }            
        );

    }

    toMap(){
        return{
            'codigo' : this.codigo, //BACKEND
            "materia": this.materia,
            'fechasistema': this.fechasistema instanceof Date ? this.fechasistema.toISOString() : this.fechasistema,
            'cliente': this.cliente,
            'preciocobrado': this.preciocobrado,
            'fechaentrega': this.fechaentrega instanceof Date ? this.fechaentrega.toISOString() : this.fechaentrega,
            'tutor': this.tutor, 
            'preciotutor': this.preciotutor,
            'identificadorcodigo': this.identificadorcodigo, //BACKEND
            'idsolicitud': this.idsolicitud,
            'idcontable' : this.idcontable, //BACKEND
            'ultimaModificacion' : this.ultimaModificacion, //BACKEND
            'referidoPor' : this.referidoPor, //DEPENDE DE SOLICITUD
            "entregatutorFecha" : this.entregatutorFecha instanceof Date ? this.entregatutorFecha.toISOString() : this.entregatutorFecha,
            'codigoReferenciaCamapa': this.codigoReferenciaCamapa,
            'creadoPor' : this.creadoPor,
            'pagos' : this.pagos,
        }
    }

    //update
    updateFromJson(updateData){
   
        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }

         Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);

            switch(field) {
                case 'materia':
                    this.materia = conversionStringJson(value,this.materia);
                    break;

                case 'cliente' :
                    this.cliente = conversionNumberJson(value,this.cliente);
                    break;

                case 'preciocobrado' :
                    this.preciocobrado = conversionNumberJson(value,this.preciocobrado);
                    break;

                case 'fechaentrega' :
                    this.fechaentrega = conversionFechaJson(value,this.fechaentrega);
                    break;

                case 'tutor':
                    this.tutor = conversionStringJson(value,this.tutor);
                    break;
                case 'preciotutor':
                    this.preciotutor = conversionNumberJson(value,this.preciotutor);
                    break;

                case 'notasContabilidad':
                    this.notasContabilidad = conversionStringJson(value,this.notasContabilidad);
                    break;

                case 'notaObtenida':
                    this.notaObtenida = conversionNumberJson(value,this.notaObtenida);
                    break;

                case 'servicioVerificado':
                    this.servicioVerificado = conversionBooleanoJson(value,this.servicioVerificado);
                    break;

                case 'objetoTesis':
                    if (value && typeof value === 'object') {
                        this.objetoTesis = value;
                        }
                    break;

                case 'objetoTesis.calendarioEnviadoACliente':
                    this.objetoTesis.calendarioEnviadoACliente = conversionBooleanoJson(value,this.objetoTesis.calendarioEnviadoACliente);
                    break;

                //involucrar pagos
                
                //no involucrar historial

                //involucrar entreas de trabjao

                case 'linkEntregaTutor':
                    this.linkEntregaTutor = conversionStringJson(value,this.linkEntregaTutor);
                    break;

                case 'entregatutorFecha':
                    this.entregatutorFecha = conversionFechaJson(value,this.entregatutorFecha);
                    break;

                case 'entregaClienteFecha':
                    this.entregaClienteFecha = conversionFechaJson(value,this.entregaClienteFecha);
                    break;

                case 'referidoPor':
                    this.referidoPor = conversionStringJson(value,this.referidoPor);
                    break;

                case 'avisoClienteEntrega':
                    this.avisoClienteEntrega = conversionBooleanoJson(value,this.avisoClienteEntrega);
                    break;

                //proplataforma se carga automaticamente, modificar desde solciitud

                //objeto de asesoria

                case 'ObjetoAsesoria.enlaceGrabacion':
                    this.ObjetoAsesoria.enlaceGrabacion = conversionStringJson(value,this.ObjetoAsesoria.enlaceGrabacion);
                    break;

                case 'preguntas':
                    this.preguntas = Array.isArray(value) ? value : this.preguntas;
                    break;

                //toca pasarlo por updatefromjson aca
                case 'revision':
                    this.revision = value;

            }

         });

    }

    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

    //get pasos
    getPasosIniciales() {
        const pasosFaltantes = [];

        // Verificación 1: ¿Está definido el calendario de avances?
        // Se comprueba si el objeto calendarioAvances no tiene claves, lo que significa que está vacío.
        if (Object.keys(this.objetoTesis.calendarioAvances).length === 0) {
            pasosFaltantes.push("Definir calendario de avances");
        }

        // Verificación 2: ¿El calendario fue enviado al cliente?
        if (this.objetoTesis.calendarioEnviadoACliente === false) {
            pasosFaltantes.push("Enviar calendario al cliente");
        }

        //verificar numero de avances puesto
        /*
        if (this.objetoTesis.numeroDeAvances == ""){
            pasosFaltantes.push('Falta definir el # de avaces')
        }
            */

        // Devolver el estado final basado en las verificaciones
        if (pasosFaltantes.length === 0) {
            // Si el array está vacío, todos los pasos se completaron.
            return "COMPLETO";
        } else {
            // Si faltan pasos, se devuelve un mensaje que los enumera.
            return `⚠️ PENDIENTE: ${pasosFaltantes.join(', ')}`;
        }
    }
    //avance de proyecto de tesis
    getAvancePagos() {
        const pagos = this.getSumaPagosClientes();
        const precioCliente = this.preciocobrado;

        // Evita la división por cero si el precio no está definido
        if (!precioCliente || precioCliente === 0) {
            return 100;
        }

        const porcentaje = (pagos / precioCliente) * 100;

        // Utiliza Math.floor() para eliminar la parte decimal
        return Math.floor(porcentaje);
    }
    getAvanceEntregas() {
        const avancesProgramados = this.entregasTrabajo.filter(entrega => entrega.motivoEntrega === 'AVANCE');

        const totalAvances = avancesProgramados.length;

        // Si no hay avances programados, el progreso es 0.
        if (totalAvances === 0) {
            return 0;
        }


        const avancesEntregados = avancesProgramados.filter(avance => avance.getTrabajoEntregado()).length;

        const porcentaje = (avancesEntregados / totalAvances) * 100;

        return Math.floor(porcentaje);
    }

    //AVANCE GENERAL DE PROYECTO
    getAvanceGeneral() {
    const pasosInicales = this.getPasosIniciales();
    const percentpagos = this.getAvancePagos();
    const percentEntregas = this.getAvanceEntregas();

    let internalStatus = '';

    // 1. Determinar el estado interno (lógica sin cambios)
    if (pasosInicales !== "COMPLETO") {
        internalStatus = 'PASOS_INICIALES';
    } else if (percentpagos >= 100 && percentEntregas >= 100) {
        internalStatus = 'FINALIZADO';
    } else if (percentpagos > percentEntregas) {
        internalStatus = 'EN_PROGRESO';
    } else if (percentpagos === percentEntregas) {
        internalStatus = 'PENDIENTE_CLIENTE';
    } else {
        internalStatus = 'PENDIENTE_PAGO';
    }

    // 2. Definir los mensajes para cada rol
    let adminMessage = '';
    let tutorMessage = '';

    switch (internalStatus) {
        case 'EN_PROGRESO':
            adminMessage = "⚙️ TRABAJO EN PROGRESO";
            tutorMessage = "✅ TESIS EN PROCESO, por favor trabaja en ella";
            break;
        case 'PENDIENTE_CLIENTE':
            adminMessage = "👤 PENDIENTE POR CLIENTE";
            tutorMessage = "🛑 TESIS PARADA, NO AVANCE HASTA QUE SE TE CONFIRME";
            break;
        case 'PENDIENTE_PAGO':
            adminMessage = "💰 PENDIENTE POR PAGO";
            tutorMessage = "🛑 TESIS PARADA, NO AVANCE HASTA QUE SE TE CONFIRME";
            break;
        case 'PASOS_INICIALES':
            adminMessage = `⏳ Faltan pasos iniciales (${pasosInicales})`;
            tutorMessage = "🦉 Completa los pasos iniciales para empezar, realiza el calendario de avances,de ser necesario, preguntale al asesor cuantos avances se necesitan";
            break;
        case 'FINALIZADO':
            adminMessage = "✅ PROYECTO FINALIZADO";
            tutorMessage = "🎉 PROYECTO FINALIZADO";
            break;
        default:
            adminMessage = "Estado no definido";
            tutorMessage = "Consultar estado con administración";
            break;
    }

    // 3. Retornar el objeto con ambos mensajes
    return {
        admin: adminMessage,
        tutor: tutorMessage
    };
}

    //Trabajo entregado por parte de tutor
    getTrabajoEntregado() {

        if (!this.entregatutorFecha || !(this.entregatutorFecha instanceof Date)) {
            return false;
        }

        // Extraer componentes para verificar la comparación visualmente
        const anio = this.entregatutorFecha.getFullYear();
        const mes = this.entregatutorFecha.getMonth(); // Recuerda: 0 es Enero
        const dia = this.entregatutorFecha.getDate();

        // Si la fecha de entrega del tutor es igual a la fecha de referencia (01/01/2023)
        if (anio === 2023 && mes === 0 && dia === 1) {
            return false;
        }

        return true;
    }

    //Trabajo entregado por parte de cliente
    getTrabajoEntregadoCliente() {

        if (["A", "P", "Q"].includes(this.identificadorcodigo)) {
            return true;
        }

        if (!this.entregaClienteFecha || !(this.entregaClienteFecha instanceof Date)) {
            return false;
        }

        const esFechaReferencia2023 = 
            this.entregaClienteFecha.getFullYear() === 2023 && 
            this.entregaClienteFecha.getMonth() === 0 && 
            this.entregaClienteFecha.getDate() === 1;

        if(this.fechaentrega.getFullYear() <= 2024){
            return true;
        }
        

        // Extraer componentes para verificar la comparación visualmente
        const anio = this.entregaClienteFecha.getFullYear();
        const mes = this.entregaClienteFecha.getMonth(); // Recuerda: 0 es Enero
        const dia = this.entregaClienteFecha.getDate();

        // Si la fecha de entrega del tutor es igual a la fecha de referencia (01/01/2023)
        if (anio === 2023 && mes === 0 && dia === 1) {
            return false;
        }

        return true;
    }

    //suma de pagos CLIENTES
    getSumaPagosClientes() {
        //console.log("suma de pagos de clientes",this.pagos);
        if (!this.pagos || !Array.isArray(this.pagos)) {
            return 0;
        }

        return this.pagos
            .filter(pago => pago.tipopago === 'CLIENTES')
            .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    }

    //PEDIENTE CLIENTE
    getSaldoPendienteCliente() {
        // 1. Obtén el precio total a cobrar, asegurándote de que sea un número.
        const totalACobrar = parseFloat(this.preciocobrado) || 0;

        // 2. Usa el método que ya tienes para obtener la suma de lo que el cliente ha pagado.
        const totalPagado = this.getSumaBalanceClientes();

        // 3. La diferencia es el saldo pendiente.
        return totalACobrar - totalPagado;
    }

    //suma de pagos REEMBOLSOCLIENTE
    getSumaReembolsosClientes() {
        if (!this.pagos || !Array.isArray(this.pagos)) {
            return 0;
        }

        return this.pagos
            .filter(pago => pago.tipopago === 'REEMBOLSOCLIENTE')
            .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    }

    //porcentaje de clientes
    getPorcentajePagoCliente(){
        // Validar que hay un precio cobrado
        if (!this.preciocobrado || this.preciocobrado <= 0) {
            return 0;
        }
        
        // Obtener el total pagado por el cliente
        const totalPagado = this.getSumaPagosClientes();
        
        // Calcular el porcentaje
        const porcentaje = (totalPagado / this.preciocobrado) * 100;
        
        // Asegurar que esté entre 0 y 100, y redondear a entero
        return Math.min(100, Math.max(0, Math.round(porcentaje)));
    }

    //suma de CLIENTES
    getSumaBalanceClientes(){
        const pagosClientes = this.getSumaPagosClientes();
        const reembolsosClientes = this.getSumaReembolsosClientes();
    
        // Balance = Pagos recibidos - Reembolsos hechos
        return pagosClientes - reembolsosClientes;
    }

    //suma de pagos TUTOR
    getSumaPagosTutores() {
        if (!this.pagos || !Array.isArray(this.pagos)) {
            return 0;
        }

        return this.pagos
            .filter(pago => pago.tipopago === 'TUTOR')
            .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    }

    //PENDIENTE UTTOR
    getSaldoPendienteTutor() {
        // 1. Obtén el precio total a cobrar, asegurándote de que sea un número.
        const totalACobrar = parseFloat(this.preciotutor) || 0;

        // 2. Usa el método que ya tienes para obtener la suma de lo que el cliente ha pagado.
        const totalPagado = this.getSumaBalanceTutor();

        // 3. La diferencia es el saldo pendiente.
        return totalACobrar - totalPagado;
    }

    //suma de pagos REEMBOLSOTUTOR
    getSumaReembolsosTutores() {
        if (!this.pagos || !Array.isArray(this.pagos)) {
            return 0;
        }

        return this.pagos
            .filter(pago => pago.tipopago === 'REEMBOLSOTUTOR')
            .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    }

    //suma de TUTOR
    getSumaBalanceTutor(){
        const pagosTutor = this.getSumaPagosTutores();
        const reembolsosTutor = this.getSumaReembolsosTutores();
        
        // Balance = Pagos hechos - Reembolsos recibidos
        return pagosTutor - reembolsosTutor;
    }

    //suma de pagos REFERIDOS
    getSumaPagosReferidos() {
        if (!this.pagos || !Array.isArray(this.pagos)) {
            return 0;
        }

        return this.pagos
            .filter(pago => pago.tipopago === 'REFERIDOS')
            .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    }

    //suma de REFERIDOS
    getSumaBalanceReferidos() {
         const pagosReferidos = this.getSumaPagosReferidos();
        // Los referidos normalmente no tienen reembolsos, pero si los hay, se pueden agregar aquí
        
        return pagosReferidos;
    }

    //METODOS
    getSumaTotalGastos() {
        return this.gastosServicio.reduce((total, gasto) => total + (parseFloat(gasto.valor) || 0), 0);
    }

    // Suma filtrada por categoría (útil para impuestos o comisiones)
    getSumaGastosPorCategoria(categoria) {
        return this.gastosServicio
            .filter(g => g.categoria === categoria)
            .reduce((total, g) => total + (parseFloat(g.valor) || 0), 0);
    }

    //REVISION DE SERVICIO
    getEstadoRevision() {
        const { activo, resuelto } = this.revision;

        if (!activo) {
            return {
                id: 'NO_INICIADA',
                label: 'Sin Revisión',
                color: 'bg-gray-100 text-gray-600 border-gray-200',
                descripcion: 'El servicio no tiene revisiones pendientes.'
            };
        }

        if (activo && !resuelto) {
            return {
                id: 'EN_CURSO',
                label: 'Revisión Activa',
                color: 'bg-orange-100 text-orange-700 border-orange-200 animate-pulse',
                descripcion: `En proceso por: ${this.revision.motivo}`
            };
        }

        if (activo && resuelto) {
            return {
                id: 'RESUELTA',
                label: 'Revisión Finalizada',
                color: 'bg-green-100 text-green-700 border-green-200',
                descripcion: 'La revisión fue completada satisfactoriamente.'
            };
        }
    }

    // Utilidad Real (Ganancia Neta)
    getUtilidadNeta() {
        const precioCliente = this.preciocobrado;
        const precioTutor = this.preciotutor;
        //const otrosGastos = this.getSumaTotalGastos();
        
        return precioCliente - precioTutor ;
    }

}

//objeto de gastos
export class GastoServicio {
    constructor({
        id = "", //generar ID
        concepto = "",
        categoria = "", // TAX, COMISION, OPERATIVO , OTROS
        valor = 0,
        fecha = new Date(),
        linkPago = "",
    } = {}){
        this.id = id;
        this.concepto = concepto;
        this.categoria = categoria;
        this.valor = valor;
        this.fecha = fecha;
        this.linkPago = linkPago;
    }

    static fromJson(json){
        return new GastoServicio({
            id: json['id'],
            concepto: json['concepto'] ?? '',
            categoria: json['categoria'] ?? 'OPERATIVO',
            valor: json['valor'] ?? 0,
            fecha: convertirFechaFirebase(json['fecha']),
            linkPago: json['linkPago'] ?? "",
        });
    }

    toMap() {
        return {
            id: this.id,
            concepto: this.concepto,
            categoria: this.categoria,
            valor: this.valor,
            fecha: this.fecha instanceof Date ? this.fecha.toISOString() : this.fecha,
            linkPago: this.linkPago,
        };
    }


}

//pagos
//nuevo estado == APROBADOS , DECLINADO
export class RegistrarPagos{
    constructor({
        id = "",
        tipopago = "",
        valor = 0,
        metodopago = '',
        referencia = '',
        fechapago = new Date(),
        fecharegistro = new Date(),
        indexPago = '',

        //automatica
        yaExiste = false,
        linkPago = "",

        //estado pago
        estado = "APROBADO" , //APROBADO , DECLINADO, PENDIENTE
        objetoWompi = {}

    } = {}){
        this.id = id;
        this.tipopago = tipopago;
        this.valor = valor;
        this.metodopago = metodopago;
        this.referencia = referencia;
        this.fechapago = fechapago;
        this.fecharegistro = fecharegistro;
        this.indexPago = indexPago;
        this.yaExiste = yaExiste;
        this.linkPago = linkPago;
        this.estado = estado;
        this.objetoWompi = objetoWompi;
    }

    static fromJson(json){

        const fechapagoLocal = convertirFechaFirebase(json['fechapago']);
        const fecharegistroLocal = convertirFechaFirebase(json['fecharegistro']);

        const objetoWompi = json['objetoWompi'] ?? {};
        let estadoFinal = json['estado'] ?? 'APROBADO';
        let valor = json['valor'] ?? 0;


        //modificacioes wompi
        if (objetoWompi && objetoWompi.status) {
        const statusWompi = objetoWompi.status.toUpperCase();
        
        if (statusWompi === 'APPROVED') {
            estadoFinal = 'APROBADO';
        } else if (['DECLINED', 'ERROR', 'VOIDED'].includes(statusWompi)) {
            estadoFinal = 'DECLINADO';
            valor = 0;
        } else if (statusWompi === 'PENDING') {
            estadoFinal = 'PENDIENTE';
            valor = 0;
        } 

        }

        //estados
        if(estadoFinal === "PENDIENTE" || estadoFinal === "DECLINADO"){
            valor = 0;
        }

        return new RegistrarPagos({
            id: json['id'] ?? '',
            tipopago: json['tipopago'] ?? '',
            valor: valor,
            metodopago: json['metodopago'] ?? '',
            referencia: json['referencia'] ?? '',
            fechapago: fechapagoLocal,
            fecharegistro: fecharegistroLocal,
            indexPago: json['indexPago'] ?? '',
            yaExiste: json['yaExiste'] ?? false,
            linkPago: json['linkPago'] ?? '',
            estado: estadoFinal,
            objetoWompi: json['objetoWompi'] ?? {},
        });
    }

    toMap(){
        return{
            'tipopago' : conversionStringJson(this.tipopago),
            'valor' : conversionNumberJson(this.valor),
            'metodopago' : conversionStringJson(this.metodopago),
            'referencia' : conversionStringJson(this.referencia),
            'fechapago' : conversionFechaJson(this.fechapago),
            'id': conversionStringJson(this.id),
            'fecharegistro' : conversionFechaJson(this.fecharegistro),
            'indexPago' : conversionStringJson(this.indexPago),
            'yaExiste' : conversionBooleanoJson(this.yaExiste),
            'linkPago' : conversionStringJson(this.linkPago),
            'estado' : conversionStringJson(this.estado),
            'objetoWompi' : this.objetoWompi,
        }
    }    

    updateFromJson(updateData){
        if(!updateData || typeof updateData !== 'object'){
            console.warn('updateData debe ser un objeto válido');
            return;
        }

        Object.keys(updateData).forEach(field => {
            const value = updateData[field];

            switch(field) {
                case 'tipopago':
                    this.tipopago = conversionStringJson(value,this.tipopago);
                    break;

                case 'valor':
                    this.valor = conversionNumberJson(value,this.valor);
                    break;

                case 'metodopago':
                    this.metodopago = conversionStringJson(value,this.metodopago);
                    break;

                case 'referencia':
                    this.referencia = conversionStringJson(value,this.referencia);
                    break;

                case 'fechapago':
                    this.fechapago = conversionFechaJson(value,this.fechapago);
                    break

                case 'indexPago':
                    this.fechapago = conversionStringJson(value,this.indexPago);
                    break

                case 'estado':
                    this.estado = conversionStringJson(value,this.estado);
                    break
            }
        })
    }

    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

}
//objeto pago
export const formPagoInicial = {
    tipopago: '',
    valor: 0,
    referencia: '',
    metodopago: '',
    fechapago: null, // Formato YYYY-MM-DD
    archivoPago: null,
    yaExiste: false,
    estado: '',
};

//pro tesis
export class ObjetoTesis{
    constructor({
        //configs iniciales
        calendarioAvances = [],
        calendarioEnviadoACliente = false,
        //numero de avances
        numeroDeAvances = "",

    } = {} ) {
        this.calendarioAvances = calendarioAvances;
        this.calendarioEnviadoACliente = calendarioEnviadoACliente;
        this.numeroDeAvances = numeroDeAvances;
    }

    static fromJson(json){
        const avances = json.calendarioAvances 
            ? json.calendarioAvances.map(avance => new CalendarioAvances(avance)) 
            : [];

        return new ObjetoTesis({
            calendarioAvances : avances, 
            calendarioEnviadoACliente: json['calendarioEnviadoACliente'] ?? false,
            numeroDeAvances: json['numeroDeAvances'] ?? '',
        });
    }

    toMap(){

    }

}

//tipos de entregas que se pueden agendar
export class EntregasParciales{
    constructor({
        id = "",
        motivo = "",
        descripcion = "",
        fechaentrega = new Date(),
        fechaSistema = new Date(),
        motivoEntrega = "",
        entregatutorFecha = new Date(),
        entregaClienteFecha = new Date(),
        linkEntregaTutor = "",
        //APROBADO POR COORDINADOR
        aprobadoCoordinador = false,
    } = {}){
        this.id = id;
        this.motivo = motivo;
        this.descripcion = descripcion;
        this.fechaentrega = fechaentrega;
        this.fechaSistema = fechaSistema;
        this.motivoEntrega = motivoEntrega;
        this.entregatutorFecha = entregatutorFecha;
        this.entregaClienteFecha = entregaClienteFecha;
        this.linkEntregaTutor = linkEntregaTutor;
        this.aprobadoCoordinador = aprobadoCoordinador;
    }

    static fromJson(json){

        const fechaentrega = convertirFechaFirebase(json['fechaentrega']);
        const fechaSistema = convertirFechaFirebase(json['fechaSistema']);
        const entregatutorFecha = convertirFechaFirebase(json['entregatutorFecha']);
        const entregaClienteFecha = convertirFechaFirebase(json['entregaClienteFecha']);

        return new EntregasParciales({
            id: json['id'] ?? "",
            motivo: json['motivo'] ?? "",
            descripcion: json['descripcion'] ?? "",
            fechaentrega: fechaentrega,
            fechaSistema: fechaSistema,
            motivoEntrega: json['motivoEntrega'] ?? "",
            entregatutorFecha: entregatutorFecha,
            entregaClienteFecha: entregaClienteFecha,
            linkEntregaTutor: json['linkEntregaTutor'] ?? "",
            aprobadoCoordinador: json['aprobadoCoordinador'] ?? false,
        });
    }

    toJson(){

    }

    toMap(){
        return{
            'id' : conversionStringJson(this.id),
            'motivo' : conversionStringJson(this.motivo),
            'descripcion': conversionStringJson(this.descripcion),
            'fechaentrega' : conversionFechaJson(this.fechaentrega),
            'fechaSistema' : conversionFechaJson(this.fechaSistema),
            'motivoEntrega' : conversionStringJson(this.motivoEntrega),
            //'entregatutorFecha' : conversionFechaJson(this.entregatutorFecha),
            //aprobadoCoordinador
        };
    }

    updateFromJson(updateData){
        console.log("uypdate data entrega temporal");

        if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
        }


        Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);

            switch(field) {
                case 'id':
                    this.id = conversionStringJson(value,this.id);
                    break;

                case 'motivo':
                    this.motivo = conversionStringJson(value,this.motivo);
                    break;

                case 'descripcion':
                    this.descripcion = conversionStringJson(value,this.descripcion);
                    break;

                case 'fechaentrega':
                    this.fechaentrega = conversionFechaJson(value,this.fechaentrega);
                    break;

                case 'fechaSistema':
                    this.fechaSistema = conversionFechaJson(value,this.fechaSistema);
                    break;
                    
                case 'motivoEntrega':
                    this.motivoEntrega = conversionStringJson(value,this.motivoEntrega);
                    break;

                case 'entregatutorFecha':
                    this.entregatutorFecha = conversionFechaJson(value,this.entregatutorFecha);
                    break;

                case 'entregaClienteFecha':
                    this.entregaClienteFecha = conversionFechaJson(value,this.entregaClienteFecha);
                    break;

                case 'linkEntregaTutor':
                    this.linkEntregaTutor = conversionStringJson(value,this.linkEntregaTutor);
                    break;
            }

         });
    }

    getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
    }

    getTrabajoEntregado(){

        const entregadoAlTutor = esFechaEntregaValida(this.entregatutorFecha);
        const entregadoAlCliente = esFechaEntregaValida(this.entregaClienteFecha);

        return entregadoAlTutor || entregadoAlCliente;
        
    }

    getTrabajoEntregadoCliente(){
        
    }


}

//COSAS
export class CalendarioAvances{
    constructor({
        numeroAvance = 0,
        detalle = "",
        fechaEntrega = "",
    } = {}) {
        this.numeroAvance = numeroAvance;
        this.detalle = detalle;
        this.fechaEntrega = fechaEntrega;
    }
}

export class Reunion{
    constructor({
        linkReunion = "",
        fechaReunion = new Date(),
        tituloReunion = "",
        notasReunion = "",
        comentariosReunion = "",
    } = {}){
        this.linkReunion = linkReunion;
        this.fechaReunion = fechaReunion;
        this.tituloReunion = tituloReunion;
        this.notasReunion = notasReunion;
        this.comentariosReunion = comentariosReunion;
    }
}

//Para revisiones
export class RevisionServicio{
    constructor({
        activo = false, //revision activa
        inicioRevision = new Date(),
        finRevision = new Date(),
        motivo = "", //PERDIDO, //PREGUNTA, //CORRECION
        concepto = "", //descripcion de como queda la revision, que se va a realizar
        resuelto = false , //true o false
        conceptoResolucion = "",
    } = {}){
        this.activo = activo;
        this.inicioRevision = inicioRevision;
        this.finRevision = finRevision;
        this.motivo = motivo;
        this.concepto = concepto;
        this.resuelto = resuelto;
        this.conceptoResolucion = conceptoResolucion;
    }

    static fromJson(json) {
        return new RevisionServicio({
            activo: json['activo'] ?? false,
            inicioRevision: convertirFechaFirebase(json['inicioRevision']),
            finRevision: convertirFechaFirebase(json['finRevision']),
            motivo: json['motivo'] ?? '',
            concepto: json['concepto'] ?? '',
            resuelto: json['resuelto'] ?? false,
            conceptoResolucion: json['conceptoResolucion'] ?? '',
        });
    }

    toMap() {
        return {
            'activo': conversionBooleanoJson(this.activo),
            'inicioRevision':  conversionFechaJson(this.inicioRevision),
            'finRevision':  conversionFechaJson(this.finRevision),
            'motivo': conversionStringJson(this.motivo),
            'concepto': conversionStringJson(this.concepto),
            'resuelto': conversionBooleanoJson(this.resuelto),
            'conceptoResolucion' : conversionStringJson(this.conceptoResolucion),
        };
    }

}
export const formRevisionServicio = {
    activo : false, //revision activa
    inicioRevision : new Date(),
    finRevision : new Date(),
    motivo : "", //PERDIDO, //PREGUNTA, //CORRECION
    concepto : "", //descripcion de como queda la revision, que se va a realizar
    resuelto : false ,
}